import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./EmployeeContactUs.css";
import JobSeekerNavbar from "../../Pages/Navbar/JobSeekerNavbar";
import Footer from "../../Footer/Footer";
import SupportContactForm from "../../Common/SupportContactForm/SupportContactForm";

const EmployeeContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JobSeekerNavbar />
      <section className="contact-us">
        <Container>
          <Row className="contact-box">
            <Col>
              <h4 className="contact-title">Contact Us</h4>
              <p className="contact-text">
                GulfWorker is a trusted platform connecting Job Seekers, Employers, and Agencies across Gulf and international markets.
                We help employers hire verified domestic workers and support candidates in finding suitable job opportunities quickly and safely.
              </p>
              <p className="contact-text">
                Our platform ensures smooth communication, reliable hiring solutions, and professional support for all users.
              </p>
              <p className="contact-text">
                We serve Saudi Arabia, UAE, Qatar, Kuwait, Oman, Bahrain, Singapore, Malaysia, Hong Kong, South Korea, Japan, Brunei, Maldives, United Kingdom, Germany, Croatia, Romania, Poland, Lithuania, Belgium, and other countries.
              </p>
              <p className="contact-text">
                For any inquiries, assistance, or support, please contact us. Our team is ready to help.
              </p>
            </Col>
          </Row>

          <Row className="form-map-section">
            <Col md={6} className="form-column">
              <div className="map-box">
                <iframe
                  title="Gudnet Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.663361947527!2d73.00846147426734!3d19.034550053274298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c3c196a0cf43%3A0x153680f6faba482f!2sGudnet%20Computers%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1774682550088!5m2!1sen!2sin"
                  width="100%"
                  height="400"
                  style={{ border: 0, borderRadius: "0px" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </Col>

            <Col md={6} className="form-column">
              <div className="form-box">
                <SupportContactForm title="Contact Us" buttonClassName="submit-btn-employee-contact" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default EmployeeContactUs;
